<template>
  <div class="scenery-box">
    <div class="box box1" @click="notifyParent"></div>
    <div class="box box2" @click="notifyParent"></div>
    <div class="box box3" @click="notifyParent"></div>
    <div class="box box4" @click="notifyParent"></div>
    <div class="box box5" @click="notifyParent"></div>
    <div class="box box6" @click="notifyParent"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    notifyParent() {
      // 触发自定义事件 'child-click'，并传递一些数据
      this.$emit("child-click", "Some data");
      console.log("123");
    },
  },
};
</script>
<style lang="less" scoped>
.scenery-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: url(~@/assets/goplay/all.png) no-repeat center center;
  // pointer-events: none;

  display: block;
  pointer-events: none;
  background: url(https://xld-project-static.oss-cn-hangzhou.aliyuncs.com/xld/theme/song/index/qing_map.jpg)
    no-repeat;
  background-size: cover;
  .box {
    width: 300px;
    height: 300px;
    background: transparent;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
  }
  .box1 {
    left: 45vh;
    top: 0vh;
  }
  .box2 {
    left: 20vh;
    top: 36vh;
  }
  .box3 {
    width: 500px;
    left: 62vh;
    top: 63vh;
  }
  .box4 {
    left: 136vh;
    top: 55vh;
  }
  .box5 {
    left: 168vh;
    top: 23vh;
  }
  .box6 {
    width: 600px;
    left: 105vh;
    top: 3vh;
  }
}
</style>
